import React, { Component, ReactElement } from 'react';
import { withStyles, Paper, CircularProgress, List, Divider, createStyles, Theme } from '@material-ui/core';
import PaginationComponent from '../Pagination';
import { WithStyles } from '@material-ui/styles';
import clsx from 'clsx';

export interface MainListProps<T> extends WithStyles<typeof STYLES> {
    list: Array<T>
    float?: 'left' | 'center'
    loading?: boolean
    addButton?: ReactElement
    onPageChange?: (pageNumber: number) => void
    totalItemsCount?: number
    search?: boolean
    chips?: boolean
    searchProps: {}
}

interface IState {
    currentPage: number
}

class MainList<T = any> extends Component<MainListProps<T>, IState> {
    constructor(props: MainListProps<T>) {
        super(props);
        this.state = {
            currentPage: 1
        }
    }
    clicked = false;

    listComponent: HTMLUListElement | null = null

    handlePageChange = (pageNumber: number) => {
        this.setState({ currentPage: pageNumber });
        if (typeof this.props.onPageChange === 'function') {
            this.props.onPageChange(pageNumber);
            if (this.listComponent) {
                this.listComponent.scrollTo(0, 0);
            }
        }
    }

    render() {
        const { classes } = this.props;
        const { list = [], loading, float = 'center', chips = false } = this.props;
        return (
            <div className={classes.mainListContainerWrapper} >
                <div className={clsx(classes.mainListContainer, float === 'left' ? classes.listLeft : classes.listCenter)}>
                    <Paper className={classes.paper}>
                        {
                            loading && <CircularProgress className={classes.listLoader} color="primary" thickness={5} />
                        }
                        {
                            !loading && list.length > 0 &&
                            <span>
                                {
                                    chips ?
                                        <div className={classes.chipsContainer}>
                                            {list}
                                        </div>
                                        :
                                        <span>
                                            <List ref={ref => this.listComponent = ref} className={classes.nav} >
                                                {list}
                                            </List>
                                            <Divider />
                                            <PaginationComponent currentPage={this.state.currentPage} totalItemsCount={this.props.totalItemsCount || 0} onPageChange={this.handlePageChange} />
                                        </span>
                                }
                            </span>
                        }

                    </Paper>
                    <div className={classes.addBtn}>{this.props.children || ''}</div>
                </div>
            </div>
        );
    }

}

const STYLES = (theme: Theme) => {
    const { palette: { primary: { light } } } = theme;
    return (
        createStyles({
            nav: {
                paddingTop: 70,
                height: 'calc(100% - 120px)',
                overflow: 'auto',
                "& .active li": {
                    backgroundColor: light,
                    color: '#fff'
                }
            },
            mainListContainerWrapper: {
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
            },
            mainListContainer: {
                position: 'fixed',
                top: 0,
                bottom: 0,
            },
            listCenter: {
                width: 400,
            },
            paper: {
                height: '100%'
            },
            listLeft: {
                width: 250,
                left: 150,
            },
            listLoader: {
                position: 'absolute',
                top: '50%',
                left: '50%'
            },
            addBtn: {
                position: 'absolute',
                bottom: '38px',
                right: '-23px'
            },
            chipsContainer: {
                paddingTop: 20,
                paddingRight: 50
            }
        })
    )
}


export default withStyles(STYLES)(MainList);